import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  useColorMode,
  Select
} from "@chakra-ui/react";
import { FooterBigText, FinePrintText, FooterStatus } from "./AppFooter.components"
import { ThemedIcon } from "../../../theme/ThemedIcon";
import { ThemedText } from "../../../theme/ThemedText";
import { ThemedLink } from "../../../theme/ThemedLink";
import { faDashboard, faHeart, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { faBtc, faTwitter } from "@fortawesome/free-brands-svg-icons"
import styled from "@emotion/styled"
import { currencySymbols } from '../../../utils/currencyConversion.utils';
import { useRecoilState } from 'recoil';
import { selectedCurrencyState } from '../../../recoilState';
const ApiStatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 5px;
  border-radius: 50%;
  background-color: ${props => (props.apiSuccess ? "green" : "red")};
`;

// Import the version number from package.json
const { version } = require('../../../../package.json');

export const AppFooter = ({ apiStatus }) => {
  const { colorMode } = useColorMode();
  const borderTopColor = colorMode === 'dark' ? 'gray.500' : 'gray.700';
  const bgColor = colorMode === 'dark' ? 'primary.500' : 'secondary.700';
  const [selectedCurrency, setSelectedCurrency] = useRecoilState(selectedCurrencyState);

  const [formattedDate, setFormattedDate] = useState('');

  useEffect(() => {
    const formatDate = () => {
      const date = new Date();
      const formatted = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'America/New_York',
        timeZoneName: 'short',
      }).format(date);

      setFormattedDate(formatted);
    };

    formatDate();
  }, []);

  return (
    <Flex
      direction="column"
    >
      <Flex
        bg={bgColor}
        direction="column"
        p="30px 20px 10px"
      >
        <ThemedText fontSize="md" mb={3}>
          Learn all about Bitcoin with live bitcoin price data, real-time bitcoin quotes and trades, bitcoin price vs. commodities, live bitcoin calculator, BTC market cap heatmaps, BTC charts, cryptocurrency news, bitcoin resources and more.
        </ThemedText>
        <FinePrintText>
          Data initialized on {formattedDate} and will refresh automatically until this page is closed. TimechainStats.com is an entertainment website. TimechainStats.com does not sell, exchange, transfer or promote any cryptocurrency. TimechainStats.com does not promote or share any affiliate links to any coins, tokens, forks, ICOs, or exchanges of any kind. This website is not intended to provide recommendations and should not be taken as investment advice. Prices are not guaranteed to be accurate. The datapoints and live bitcoin price visualizations on TimechainStats.com are powered by public data sourced from top exchanges and market data providers, such as Mempool.Space, NakamotoInstitute, CoinCap, Blockchain.info, CryptoCompare, CoinGecko, Messari Crypto and more. This content is for informational purposes only and does not constitute an offer to sell or the solicitation of an offer to sell or buy any security in any jurisdiction where such an offer or solicitation would be illegal. There is not enough information contained in this content to make an investment decision and any information contained herein should not be used as a basis for this purpose. This content does not constitute a recommendation or take into account the particular investment objectives, financial situations, or needs of investors. Investors are not to construe this content as legal, tax or investment advice, and should consult their own advisors concerning an investment in digital assets. The price and value of assets referred to in this content and the income from them may fluctuate. Past performance is not indicative of the future performance of any assets referred to herein. Fluctuations in exchange rates could have adverse effects on the value or price of, or income derived from, certain investments. TimechainStats.com does not verify any data reported via 3rd-party APIs and disclaims any obligation to do so. Please complete your own comprehensive research before using or investing in any cryptocurrency. Extreme risks exist, such as evolving global regulations; high price volatility; fraudulent actors and/or projects; or the threat of hackers breaking security systems and stealing funds. Any investment could lose significant value at any time. Learn about bitcoin wallets and practice secure storage procedures. TimechainStats.com is a Bitcoin-only platform. We believe all cryptocurrencies are attacks on the Bitcoin network or scams and should be avoided.
        </FinePrintText>
        <FinePrintText>
          *WTI Oil price provided by SwissQuotes API. Any calculations regarding oil price and/or natural gas price are educational only and SHOULD NOT be used for investment purposes.
        </FinePrintText>
        <FinePrintText>
          **Not all nodes are visible on the public web. See Bitnodes for more information about Bitcoin nodes. Learn about the difference between different types of nodes.
        </FinePrintText>
        <FinePrintText>
          ***Informational purposes only. International exchange rate may be delayed by up to 5 minutes. All prices are only estimates and may be incorrect.
        </FinePrintText>
        <Flex mt={3}>
          <ThemedIcon icon={faBtc} />
          <FooterBigText ml={3}>
            Bitcoin = BTC
          </FooterBigText>
        </Flex>
        <Flex>
          <ThemedIcon icon={faTwitter} />
          <FooterBigText>
            Follow <ThemedLink href="https://twitter.com/TimechainStats">@TimechainStats</ThemedLink>
          </FooterBigText>
        </Flex>
        <Flex>
          <ThemedIcon icon={faHeart} />
          <FooterBigText>
            Built by <ThemedLink href="https://twitter.com/2140data">@2140data</ThemedLink>
          </FooterBigText>
        </Flex>
        <Flex>
          <ThemedIcon icon={faDashboard} />
          <FooterBigText>
            Try the <ThemedLink href="/custom">Dashboard Builder</ThemedLink>
          </FooterBigText>
        </Flex>
        <Flex justify="space-between" align="center">
          <Flex>
            <ThemedIcon icon={faQuestionCircle} />
            <FooterBigText>
              <ThemedLink href="#" onClick={(e) => {
                e.preventDefault();
                // Dispatch a custom event to show the tutorial
                window.dispatchEvent(new CustomEvent('showMetricsTutorial'));
              }}>Tip & Tricks</ThemedLink>
            </FooterBigText>
          </Flex>
          
          <Select
            value={selectedCurrency}
            onChange={(e) => setSelectedCurrency(e.target.value)}
            size="xs"
            width="100px"
            height="26px"
            bg={colorMode === 'dark' ? 'black' : 'white'}
            borderColor={colorMode === 'dark' ? 'gray.500' : 'gray.700'}
            borderWidth="1px"
            borderRadius="4px"
            color={colorMode === 'dark' ? 'gray.500' : 'gray.700'}
            fontSize="xs"
            fontWeight="600"
            _hover={{
              borderColor: colorMode === 'dark' ? 'gray.400' : 'gray.600',
              color: colorMode === 'dark' ? 'gray.400' : 'gray.600'
            }}
            _focus={{
              borderColor: colorMode === 'dark' ? 'orange.500' : '#0d579b',
              boxShadow: 'none',
              outline: 'none'
            }}
            sx={{
              option: {
                bg: colorMode === 'dark' ? 'black' : 'white',
                color: colorMode === 'dark' ? 'gray.500' : 'gray.700',
                _hover: {
                  bg: colorMode === 'dark' ? 'gray.900' : 'gray.100'
                }
              }
            }}
          >
            {Object.entries(currencySymbols).map(([currency, symbol]) => (
              <option key={currency} value={currency}>
                {symbol} {currency.toUpperCase()}
              </option>
            ))}
          </Select>
        </Flex>
      </Flex>

      <Flex
        borderTopWidth={1}
        borderColor={borderTopColor}
        h="36px"
        align="center"
        px="20px"
        justify="space-between"
      >
        <Flex
          alignSelf="stretch"
        >
          <FooterStatus pl="0">
            BITCOIN ONLY
          </FooterStatus>

          <FooterStatus>
            VERSION {version}
          </FooterStatus>

          <FooterStatus>
            ALL DATA SYSTEMS
            <ApiStatusDot apiSuccess={apiStatus} />
          </FooterStatus>

        </Flex>

        <Flex
          alignSelf="stretch"
          alignItems="center"
        >
          <Box display={{ base: 'none', xs: 'none', 'sm2': 'none', sm: 'none', md: 'none', lg: 'none', xl: 'none', '2xl': 'block' }}>
          <FooterStatus pr="0">
              <a href="/custom" style={{ color: 'inherit', textDecoration: 'none' }}>VIRES IN NUMERIS</a>
            </FooterStatus>
          </Box>
        </Flex>
      </Flex>
    </Flex>
  )
}